export default "__VITE_ASSET__C3KcuELG__"